import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { NoticeService } from '@millionshow/api-client';
import { Icon, SafeHtmlPipe } from '@millionshow/client-libs';
import FileDownloadComponent from 'packages/client-libs/src/components/file-download/file-download.component';
import { injectParams } from 'ngxtension/inject-params';
import { of } from 'rxjs';

@Component({
  selector: 'app-notice-detail',
  imports: [
    CommonModule,
    RouterLink,
    Icon,
    SafeHtmlPipe,
    FileDownloadComponent,
  ],
  templateUrl: './notice-detail.page.html',
})
export default class NoticeDetailPage {
  private readonly noticeService = inject<NoticeService>(NoticeService);

  readonly id = injectParams('id');

  $data = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.noticeService.noticeControllerFindByIdV1({ id: params.id })
        : of(null),
  });

  readonly data = computed(() => this.$data.value());
  files = computed(() => this.data()?.files ?? []);

  $adjacentNotices = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.noticeService.noticeControllerFindAdjacentV1({
            id: params.id,
          })
        : of(null),
  });

  prevNotice = computed(() => this.$adjacentNotices.value()?.prev ?? null);
  nextNotice = computed(() => this.$adjacentNotices.value()?.next ?? null);

  stripHtml(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
}
